import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "PopupHeadline px-2 py-4 bg-brand_beige_light text-center",
    style: { "position": "sticky", "z-index": "2", "top": "0" }
};
const _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        class: "guaranteePopup",
        modelValue: _ctx.openPopup,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.openPopup) = $event)),
        width: "1100",
        "max-height": "80vh"
    }, {
        default: _withCtx(({ isActive }) => [
            _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "h5-responsive strong p-0 m-0 d-inline-block" }, "36 Monate Garantie", -1)),
                        _createElementVNode("i", {
                            onClick: ($event) => (isActive.value = false),
                            class: "icon-cancel pointerhover float-right pr-2"
                        }, null, 8, _hoisted_2)
                    ]),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row" }, [
                        _createElementVNode("div", { class: "col-12 px-4" }, [
                            _createElementVNode("p", { class: "h3-responsive [ mt-sm-45 mt-3 ] [ mb-sm-3 mb-2 ] text-lg-center text-left" }, [
                                _createTextVNode(" 36 Monate Geräteschutz mit der "),
                                _createElementVNode("span", { class: "d-inline-block" }, "mySWOOOP"),
                                _createTextVNode(" -Garantie ")
                            ]),
                            _createElementVNode("p", { class: "text-lg-center text-left mb-45" }, [
                                _createTextVNode(" Erfahre mehr dazu in unseren "),
                                _createElementVNode("a", {
                                    href: "https://cdn.myschubert.com/docs/mySWOOOP_Garantiebedingungen_36M.pdf",
                                    class: "link-gray strong",
                                    title: "mySWOOOP Garantiebedingungen",
                                    target: "_blank"
                                }, " Garantiebedingungen "),
                                _createTextVNode(" . ")
                            ])
                        ]),
                        _createElementVNode("div", { class: "col-12" }, [
                            _createElementVNode("div", { class: "row no-gutters" }, [
                                _createElementVNode("div", { class: "col-lg-8 pl-lg-5 pl-3 font7-responsive" }, [
                                    _createElementVNode("img", {
                                        src: "images/_new_brand/icons_in_brand_design/icon_guarantee.png",
                                        alt: "36 Monate Garantie",
                                        style: { "max-width": "39px", "max-height": "39px" },
                                        class: "mb-3",
                                        "data-max-width": "39",
                                        "data-max-height": "39"
                                    }),
                                    _createElementVNode("p", { class: "h6-responsive" }, "Umfang der Garantie"),
                                    _createElementVNode("p", { class: "mb-45" }, " Du erhältst auf dein Gerät ab Kaufdatum 36 Monate Garantie. Diese umfasst alle Funktionen des gekauften Geräts, die bei der Werksauslieferung vom Hersteller als technische Spezifikationen des jeweiligen Geräts definiert wurden. Die gesetzlichen Gewährleistungsrechte bleiben gemäß der Garantiebedingungen durch die 36-Monate-Garantie unberührt. "),
                                    _createElementVNode("img", {
                                        src: "images/_new_brand/icons_in_brand_design/icon_repair.png",
                                        alt: "Schnelle Reparatur",
                                        style: { "max-width": "39px", "max-height": "39px" },
                                        class: "mb-3",
                                        "data-max-width": "39",
                                        "data-max-height": "39"
                                    }),
                                    _createElementVNode("p", { class: "h6-responsive" }, "Schnelle Reparatur oder Geräteaustausch"),
                                    _createElementVNode("p", { class: "mb-45" }, " Funktioniert dein Gerät während des Garantiezeitraums nicht mehr einwandfrei, versuchen wir, es zu reparieren. Ist eine Reparatur nicht möglich, erhältst du von uns ein gleichwertiges Austauschgerät. Sollte auch ein Austausch nicht möglich sein, erstatten wir dir den Rechnungsbetrag für dein Gerät auf die beim Kauf genutzte Zahlungsart. "),
                                    _createElementVNode("img", {
                                        src: "images/_new_brand/icons_in_brand_design/icon_customer_support.png",
                                        alt: "Kunden Support",
                                        style: { "max-width": "39px", "max-height": "39px" },
                                        class: "mb-3",
                                        "data-max-width": "39",
                                        "data-max-height": "39"
                                    }),
                                    _createElementVNode("p", { class: "h6-responsive" }, "Problem im Garantiezeitraum melden"),
                                    _createElementVNode("p", { class: "mb-5" }, " Wir sind von unseren refurbishten Geräten absolut überzeugt. Willst du dennoch einen Garantiefall reklamieren, kannst du die Garantieleistung telefonisch, per E-Mail oder vor Ort in unseren Stores anmelden – je nachdem, über welchen Kanal du deine ursprüngliche Bestellung getätigt hast. ")
                                ]),
                                _createElementVNode("div", {
                                    class: "col-lg-4 d-lg-flex d-none flex-column align-items-center",
                                    style: {}
                                }, [
                                    _createElementVNode("img", {
                                        src: "/images/garantie/36_Monate_Garantie_bei_mySWOOOP.png",
                                        alt: "36 Monate Garantie bei mySWOOOP",
                                        style: { "max-width": "80%" },
                                        class: "d-block"
                                    }),
                                    _createElementVNode("a", {
                                        href: "https://cdn.myschubert.com/docs/mySWOOOP_Garantiebedingungen_36M.pdf",
                                        target: "_blank",
                                        title: "Zu den mySWOOOP Garantiebedingungen",
                                        class: "mt-3 link-gray strong"
                                    }, " Garantiebedingungen ")
                                ])
                            ])
                        ])
                    ], -1))
                ]),
                _: 2
            }, 1024)
        ]),
        _: 1
    }, 8, ["modelValue"]));
}
